/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import LaybuyCheckoutPriceBreakdown from './laybuy-checkout-price-breakdown';
import LaybuyButton from './LaybuyButton';
import { ILaybuyButtonData } from './LaybuyButton.props';

export interface ICittaPaymentLaybuyTabContentProps {
    laybuyImgSrc: string;
    instalmentAmount: string;
    errorMsg: string;
    laybuyTabState: ILaybuyButtonData;
    onClick(): void
}

const CittaPaymentLaybuyContentTab = ({
    laybuyImgSrc,
    instalmentAmount,
    errorMsg,
    laybuyTabState,
    onClick
}:ICittaPaymentLaybuyTabContentProps) => {
    return (
      <div className='lb'>
        <div className='order-wizard-paymentmethod-external-module-row'>
          <div className='order-wizard-paymentmethod-external-module-column-left'>
            <img
              src={laybuyImgSrc} // Logo_Grape-black.svg
              width='150px'
              alt='LayBuy'
            />
          </div>
          <div className='order-wizard-paymentmethod-external-module-column-right'>
            <p>Own it now, Pay Later with layBuy</p>
          </div>
          <LaybuyCheckoutPriceBreakdown price={instalmentAmount} />
          <LaybuyButton
            buttonData={laybuyTabState}
            errMsg={errorMsg}
            onClick={onClick}
          />
        </div>
      </div>
    );
};

export default React.memo(CittaPaymentLaybuyContentTab);